import { useState } from "react";
import { toast } from "sonner";
import { emailTrip, apiError } from "@/lib/api";
import { track } from "@/lib/analytics";
import { useLang } from "@/i18n";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const emailedKey = (tripId) => `ts_emailed_${tripId}`;

export const useEmailSend = (tripId, source) => {
  const { t, lang } = useLang();
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e, onSent) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email.trim())) return toast.error(t("Inserisci un indirizzo email valido."));
    if (!consent) return toast.error(t("Accetta la privacy policy per continuare."));
    setBusy(true);
    try {
      await emailTrip(tripId, { email: email.trim(), consent, lang, source });
      localStorage.setItem(emailedKey(tripId), "1");
      track("email_request_completed", { source, site_language: lang });
      onSent(email.trim());
    } catch (err) {
      toast.error(t(apiError(err)));
    } finally {
      setBusy(false);
    }
  };
  return { email, setEmail, consent, setConsent, busy, submit };
};
